import api from "../api/axios";

//Types
import { UpdateClientProfilePayload } from "../Types/CompanyProfile/CompanyProfile";

export const COMPANY_QUERY_KEY = ["company-master"];
export const VIEW_COMPANY_QUERY_KEY = ["view-copmany-profile"];

export const companyprofileService = {
  //MASTER DATA TABLE ==============================================================
  getCompanyProfile: async (code: string) => {
    const response = await api.get(`api/company-master/${code}`);
    return response.data;
  },

  updateCompanyProfile: async (
    code: string,
    payload: UpdateClientProfilePayload,
  ) => {
    const response = await api.patch(`api/company-master/${code}`, payload);
    return response.data;
  },

  updateCompanyLogo: async (code: string, payload: FormData) => {
    const response = await api.post(`api/company-master/${code}`, payload, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  },

  createCompanyProfile: async (payload: FormData) => {
    const response = await api.post(`api/company-master`, payload, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  },

  //VIEW TABLE ==============================================================
  getAllViewCompanyProfile: async () => {
    const response = await api.get(`api/view-company-profile`);
    return response.data;
  },

  getViewCompanyProfile: async (code: string) => {
    const response = await api.get(`api/view-company-profile/${code}`);
    return response.data;
  },
};
